import React, { useState } from 'react';
import { Info, PanelRightOpen } from 'lucide-react';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from 'src/shared/components/ui/sheet';
import ReadMore from 'src/shared/components/read-more/ReadMore';
import MinimalMarkdown from 'src/shared/components/minimal-markdown/MinimalMarkdown';
import QuestionButtonHelp from 'src/shared/components/question-button-help/QuestionButtonHelp';

export type NatureStatusCardProps = {
    text: string | null;
    isLoading: boolean;
};

const NatureStatusCard = ({ text, isLoading }: NatureStatusCardProps) => {
    const [showSheet, setShowSheet] = useState(false);

    if (isLoading) {
        return (
            <div className='bg-white shadow-portfolio-summary-card rounded-lg p-4 flex flex-col gap-3 animate-pulse h-full'>
                <div className='h-4 bg-grey-20 rounded w-1/3' />
                <div className='h-3 bg-grey-20 rounded w-full' />
                <div className='h-3 bg-grey-20 rounded w-5/6' />
                <div className='h-3 bg-grey-20 rounded w-4/6' />
            </div>
        );
    }

    return (
        <div className='bg-white shadow-portfolio-summary-card rounded-lg p-4 flex flex-col gap-3 h-full'>
            <div className='flex items-center justify-between'>
                <div className='flex items-center gap-2'>
                    <span className='text-[20px] font-normal text-primary'>Nature Status</span>
                    <QuestionButtonHelp type='api' slug='nature-status' placement='top' icon={<Info className='h-4 w-4 text-primary' />} />
                </div>
                {text && (
                    <button
                        type='button'
                        data-testid='read-more-btn'
                        className='border border-border rounded-lg px-2 py-1 text-xs text-foreground flex items-center gap-1'
                        onClick={() => setShowSheet(true)}
                    >
                        Read more <PanelRightOpen className='h-3 w-3' />
                    </button>
                )}
            </div>

            {text ? (
                <ReadMore text={text} lines={7} modalTitle='Nature Status' onExpand={() => setShowSheet(true)} renderAsMarkdown />
            ) : (
                <div className='flex items-center justify-center h-[130px] px-4 text-center'>
                    <p className='text-sm text-grey-80'>Nature Status currently unavailable.</p>
                </div>
            )}

            <Sheet open={showSheet} onOpenChange={setShowSheet}>
                <SheetContent className='flex flex-col w-full sm:max-w-md'>
                    <SheetHeader>
                        <SheetTitle>Nature Status</SheetTitle>
                    </SheetHeader>
                    <div className='text-sm text-black overflow-y-auto flex-1'>{text && <MinimalMarkdown text={text} />}</div>
                </SheetContent>
            </Sheet>
        </div>
    );
};

export default NatureStatusCard;
